// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rShuj","mainHeader":"styles_mainHeader__-NgvK","subHeader":"styles_subHeader__feFrB"};